module.exports = __webpack_public_path__ + "static/media/skype.aecc8aa3.svg";